import { WhitelabelConfig } from './whitelabel-config.model';

export const WHITELABEL_OPTIONAL_DEFAULTS: WhitelabelConfig = {
  site: {
    type: 'operator',
    name: '',
    legalName: '',
    alternateNames: [],
    domain: '',
    countryName: '',
    countryCode: '',
    countryNumber: '',
    currency: '',
    supportNumber: '',
    supportEmail: '',
    whatsappNumber: '',
    address: '',
    operatorAbout: '',
    canReturn: false,
    sameOperatorReturn: true,
    showFilter: true,
    showOtherDestinations: false,
    indexed: false,
    canonicalUrl: '',
    marketplaceUrl: ''
  },
  self: {
    layout: 'layout-three',
    logo: '',
    logoLight: '',
    favIcon: '',
    banner: '',
    bannerGradient: true,
    headerPanel: 'fixed',
    headerMenu: 'show'
  },
  colors: {
    primary: '#C81E2A',
    primaryTextColor: '#FFFFFF',
    secondary: '#9F1721',
    secondaryButtonText: '#FFFFFF',
    font: '#333333',
    bg: '#FFFFFF',
    heading: '#171923',
    logo: '#151B1D',
    border: '#DDDDDD',
    borderLight: '#EEEEEE',
    footerBg: '#171923',
    footerLight: '#333333',
    nav: '#171923',
    navLight: '#FFFFFF',
    dropdown: '#F5F5F5',
    bgLight: 'rgba(200, 30, 42, 0.05)',
    bgLight1: 'rgba(255, 255, 255, 0.15)',
    bgLight6: '#C81E2A',
    bannerBg: '#C81E2A',
    bannerFont: '#FFFFFF',
    bannerTextColor: '#FFFFFF'
  },
  fonts: {
    body: 'Plus Jakarta Sans',
    title: 'Plus Jakarta Sans',
    bodyWeight: 400,
    titleWeight: 700,
    useFonts: true
  },
  texts: {
    bannerTitle: '',
    bannerSubtitle: '',
    whySectionTitle: '',
    whySectionContent: ''
  },
  partnerOperators: [],
  paymentOptions: [],
  routeConfig: {
    appName: '',
    operatorIds: [],
    altRoutes: {
      fromCitiesExcluded: [],
      toCitiesExcluded: [],
      maxDistance: 50
    }
  },
  content: {},
  seo: {},
  socialLinks: {
    facebook: '',
    twitter: '',
    instagram: '',
    linkedin: '',
    youtube: ''
  },
  slides: [],
  operatingCountries: [],
  passengerValidation: {
    documentTypes: [
      { value: 'national_id', label: 'National ID' },
      { value: 'passport', label: 'Passport' }
    ],
    defaultDocumentType: 'national_id',
    documentNumberMinLength: 4,
    documentNumberMaxLength: 30,
    phoneCountries: [
      { name: 'Kenya', dialCode: '254', placeholder: '712 345 678' },
      { name: 'Uganda', dialCode: '256', placeholder: '772 123 456' }
    ],
    defaultPhoneCountryCode: '254',
    phoneMinDigits: 7,
    phoneMaxDigits: 15,
    nameMinLength: 2
  },
  googleTagManagerId: '',
  useRollbar: false
};
